import { useEffect } from 'react';
import { UploadInvoiceForm } from 'components';
import { faFileInvoice } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './UploadInvoicePage.module.scss';

export default function UploadInvoicePage() {

    useEffect(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
    });

    return (
        <div className={styles.page}>
            <div className={styles.pageContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.pageName}>
                        <FontAwesomeIcon icon={faFileInvoice} transform="grow-2" />
                        <span className={styles.pageNameText}>Upload a Missing Invoice</span>
                    </div>
                </div>
                <div className={styles.formContainer}>
                    <div className={styles.form}>
                        <UploadInvoiceForm />
                    </div>
                </div>
            </div>
        </div>
    )
}